export type InsightsSseHandler = (event: string, data: unknown) => void;

/**
 * Consume Mastra/Hono SSE (`event:` + `data:` lines).
 * Returns when the stream ends or abort fires.
 */
export async function consumeInsightsSse(
  response: Response,
  onEvent: InsightsSseHandler,
  signal?: AbortSignal,
): Promise<void> {
  if (!response.body) {
    throw new Error("No response body");
  }
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let eventName = "message";

  const abort = () => {
    try {
      reader.cancel();
    } catch {
      // ignore
    }
  };
  signal?.addEventListener("abort", abort, { once: true });

  try {
    while (true) {
      if (signal?.aborted) break;
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split("\n");
      buffer = lines.pop() ?? "";
      for (const line of lines) {
        if (line.startsWith("event:")) {
          eventName = line.slice(6).trim();
          continue;
        }
        if (!line.startsWith("data:")) continue;
        const raw = line.slice(5).trim();
        if (!raw || raw === "[DONE]") {
          eventName = "message";
          continue;
        }
        try {
          onEvent(eventName, JSON.parse(raw));
        } catch {
          onEvent(eventName, raw);
        }
        eventName = "message";
      }
    }
  } finally {
    signal?.removeEventListener("abort", abort);
  }
}
